// extracted by mini-css-extract-plugin
export default {"component":"BonusHeader__component--lc-DnGrs","title":"BonusHeader__title--lc-vAj5T","time":"BonusHeader__time--lc-YKbQH","icon":"BonusHeader__icon--lc-QvyXa"};